app.service("footerRecentArticles", function (_, lazyLoad) {
	let $self, $recentArticlesList;

	function init() {
		$self = $("#footer-recent-articles");
		$recentArticlesList = $(".footer-recent-articles-list", $self);

		if ($self.length) {
		const lazyLoadUpdateImages = _.debounce(function () {
			lazyLoad.update();
		}, 200);
		$recentArticlesList.on("touchend scroll", lazyLoadUpdateImages);
		}
	}

	return { init };
});
